import { cn } from "@/lib/cn";

export function BrandLogo({
  size = 32,
  withText = true,
  className,
}: {
  size?: number;
  withText?: boolean;
  className?: string;
}) {
  return (
    <span className={cn("inline-flex items-center gap-3", className)}>
      <span
        role="img"
        aria-label="Trinium logo mark"
        style={{ width: size, height: size }}
        className="bg-[url('/images/logo-mark.png')] bg-contain bg-center bg-no-repeat shrink-0"
      />
      {withText ? <span className="text-[19px] font-semibold tracking-tight">Trinium</span> : null}
    </span>
  );
}
